  $(document).ready(function () { 
    function addRechargeWidget(productid){
      const config = {
        productId: productid,
        injectionParent: '#add-item-form',
        injectionMethod: 'prepend',
        injectFn: (node, target) => {},
      };
      if (window.ReChargeWidget && window.ReChargeWidget.createWidget) {
        window.ReChargeWidget.createWidget(config);
      }
    }
    
   function displayQuickViewModal(producturl, productid) {
  $(".quickview-modal-wrapper").remove();

  const modal = $('<div>').addClass("quickview-modal-wrapper");

  $.ajax({
    type: 'GET',
    url: producturl + "?view=quickview",
    success: function(html) {
      modal.html(`
        <div class="quickview-modal-backdrop"></div>
        <div class="quickview-modal-content" data-product-url="${producturl}">
          <button class="quickview-close-btn">
            <svg xmlns="http://www.w3.org/2000/svg" fill="white" height="24" viewBox="0 -960 960 960" width="24">
              <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/>
            </svg>
          </button>
          ${html}
        </div>
      `);

          $('body').css('overflow', 'hidden').append(modal);

          try { new Yotpo.API(yotpo).refreshWidgets(); } catch(e) {}
          try { addRechargeWidget(productid); } catch(err) { console.log(err); }

          function removeModal(){
            $(".quickview-modal-wrapper").remove();
            $('body').css('overflow', 'auto');
            try { window.ReChargeWidget.destroyWidgets(); } catch(e) {}
          }

          $('.quickview-close-btn, .quickview-modal-backdrop').on('click', removeModal);
        },
        error: function(err) {
          console.log("Error loading quickview modal: ", err);
        }
      });
    }

    // ✅ Delegated click handler for dynamic content
    $(document).on('click', '.quickview-btn', function(e){
      e.preventDefault();
      e.stopPropagation();
      displayQuickViewModal(
        $(this).data('product-url'),
        $(this).data('product-id')
      );
    });
  });

  window['ThemeSection_ProductQuickViewBuy'] = ({ product, variant }) => {
    return {
      productRoot: null,
      product,
      current_variant: variant,
      loading: false,
      quantity: '1',
      addedToCart: false,
      disablePurchase: false,

      init() {


        this.productRoot = this.$root;

        const hasNoPurchaseTag =
          Array.isArray(this.product.tags) &&
          this.product.tags.includes('no-purchase');

        const isZeroPrice =
          this.current_variant &&
          Number(this.current_variant.price) === 0;

        this.disablePurchase = hasNoPurchaseTag || isZeroPrice;

        if (this.disablePurchase) {
          this.swapToViewProduct();
          return;
        }

        if (this.$refs.productForm) {
          this.$refs.productForm.addEventListener(
            'submit',
            this.submitForm.bind(this)
          );
        }
      },

     swapToViewProduct() {
  const form = this.$root.querySelector('.quickview-buy-product-form');
  if (!form) return;

  // Try multiple ways to get the product URL
  const productUrl = 
    this.$root.dataset.productUrl ||
    this.$root.closest('[data-product-url]')?.dataset.productUrl ||
    this.product.url ||
    form.closest('[data-product-url]')?.dataset.productUrl ||
    '#';



  form.innerHTML = `
    <a href="${productUrl}" class="btn btn--primary btn--full quickview-view-product">
      View product
    </a>
  `;
},

      submitForm(evt) {
        evt.preventDefault();
        if (this.disablePurchase) return;

        this.loading = true;
        liveRegion(window.theme.strings.loading);

        const formData = new FormData(this.$root.querySelector('.quickview-buy-product-form'));

        const config = fetchConfigDefaults('javascript');
        formData.append('sections', 'cart-items,cart-footer,cart-item-count');
        formData.append('sections_url', window.location.pathname);

        config.body = formData;
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        fetch(`${theme.routes.cart_add_url}`, config)
          .then(res => res.json())
          .then(data => {
            this.loading = false;
            this.addedToCart = true;

            document.body.dispatchEvent(
              new CustomEvent('shapes:modalcart:afteradditem', {
                bubbles: true,
                detail: { response: data },
              })
            );
          })
          .catch(error => {
            error.json().then(a => {
              this.loading = false;
              alert(a.description);
            });
          });
      },
    };
  };
